module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-06.40e1d423.png";